import { render, staticRenderFns } from "./PageWineUpdateNotApprovedForm.vue?vue&type=template&id=f5c323fa"
import script from "./PageWineUpdateNotApprovedForm.vue?vue&type=script&lang=ts"
export * from "./PageWineUpdateNotApprovedForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports